import Page     from "./Page";
import debounce from 'debounce';

export default class Episode extends Page
{
	constructor ()
	{
		console.log( 'Episode' );
		super();

		const $swiperTest = document.querySelectorAll( '.swiper' );
		if ( $swiperTest.length < 1 )
		{
			return;
		}


		this.allVideoSlides = document.querySelectorAll( '.slideshow .slide_video' );


		this.prepareSwiper();
		this.createSwiper( null );


		this.desktopBreakpoint = 768;
		this.episodeNavs       = Array.from( document.querySelectorAll( '.nav-row .episode-nav-container' ) );
		this.bindEvents();
	}


	bindEvents ()
	{

		const debouncedResize = debounce( this.handleResize.bind( this ), 500 );

		window.addEventListener( 'resize', debouncedResize );
		// first time
		this.handleResize();

	}


	prepareSwiper ()
	{
		if ( this.allVideoSlides.length > 0 )
		{
			this.allPlayerInstances = [];
			Array.from( this.allVideoSlides ).forEach( videoSlide =>
			{
				const videoPlayerInstance = videojs( videoSlide );


				videoPlayerInstance.ready( () =>
				{

					console.log( 'player', videoPlayerInstance )
					// let player = this;
					videoPlayerInstance.on( 'ended', function ()
					{
						console.log( 'video is done!' );
						videoPlayerInstance.posterImage.el_.style.display   = 'block';
						videoPlayerInstance.bigPlayButton.el_.style.display = 'block';
						videoPlayerInstance.controlBar.el_.style.display    = 'none';
					} );

					videoPlayerInstance.on( 'pause', function ()
					{
						console.log( 'video is paused!' );
						videoPlayerInstance.posterImage.el_.style.display   = 'block';
						videoPlayerInstance.bigPlayButton.el_.style.display = 'block';
						videoPlayerInstance.controlBar.el_.style.display    = 'none';
					} );

					videoPlayerInstance.on( 'playing', function ()
					{
						console.log( 'video is playing' );
						videoPlayerInstance.posterImage.el_.style.display   = 'none';
						videoPlayerInstance.bigPlayButton.el_.style.display = 'none';
						videoPlayerInstance.controlBar.el_.style.display    = 'flex';
					} );


					this.allPlayerInstances.push( videoPlayerInstance );
				} );
			} )
		}
	}

	createSwiper ( player )
	{
		this.btnPrev = (document.getElementsByClassName( 'btn_prev' ))[ 0 ];
		this.btnNext = (document.getElementsByClassName( 'btn_next' ))[ 0 ];

		this.mySwiper = new Swiper( '.swiper', {
			direction      : 'horizontal',
			loop           : false,
			allowTouchMove : false,
			slidesPerView  : 1,
			navigation     : {
				nextEl : '.btn_next',
				prevEl : '.btn_prev',
			},
			on             : {
				slideChangeTransitionEnd : function ()
				{
					if ( this.allPlayerInstances && this.allPlayerInstances.length > 0 )
					{
						Array.from( this.allPlayerInstances ).forEach( ( player ) =>
						{
							player.pause();
						} )
					}
					this.checkArrowVisibility();
				}.bind( this ),
			},

		} );

		this.checkArrowVisibility();
	}

	checkArrowVisibility ()
	{
		if ( this.mySwiper.isBeginning )
		{
			if ( this.btnPrev.style.display != 'none' )
			{
				this.btnPrev.style.display = 'none';
			}
		} else
		{
			if ( this.btnPrev.style.display == 'none' )
			{
				this.btnPrev.style.display = 'block';
			}
		}

		if ( this.mySwiper.isEnd )
		{
			if ( this.btnNext.style.display != 'none' )
			{
				this.btnNext.style.display = 'none';
			}
		} else
		{
			if ( this.btnNext.style.display == 'none' )
			{
				this.btnNext.style.display = 'block';
			}
		}
	}

	handleResize ()
	{

		if ( window.innerWidth < this.desktopBreakpoint )
		{
			this.destroyEqualEpisodeNav();
		} else
		{
			this.equalizeEpisodeNav();
		}
	}

	equalizeEpisodeNav ()
	{

		let widest = 0;

		// figure out the widest
		this.episodeNavs.forEach( nav =>
		{
			nav.style.width = 'auto';

			const width = nav.getBoundingClientRect().width;

			if ( width > widest )
			{
				widest = width;
			}
		} );


		this.episodeNavs.forEach( nav => nav.style.width = widest + 'px');
		// console.log( 'Adjust episode nav', widest );
	}

	destroyEqualEpisodeNav ()
	{
		// console.log( 'Destroy episode nav' );
		this.episodeNavs.forEach( nav =>
		{
			nav.style.width = 'auto';

		} );
	}
}